
import React from "react";
import { Control } from "react-hook-form";
import { Checkbox } from "@/components/ui/checkbox";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { DayOfWeek } from "@/models/Schedule";
import { useTranslation } from "react-i18next";
import { TimeSlotFormData } from "./timeSlotFormSchema";

const DAYS: DayOfWeek[] = [
  'monday',
  'tuesday', 
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
];

interface DaySelectionFieldProps {
  control: Control<TimeSlotFormData>;
}

const DaySelectionField: React.FC<DaySelectionFieldProps> = ({ control }) => {
  const { t } = useTranslation();

  const getDayTranslation = (day: DayOfWeek) => {
    return t(`schedule.days.${day}`);
  };

  return (
    <FormField
      control={control}
      name="selectedDays"
      render={() => (
        <FormItem>
          <FormLabel>{t('schedule.form.selectDays')}</FormLabel>
          <div className="grid grid-cols-2 gap-2">
            {DAYS.map((day) => (
              <FormField
                key={day}
                control={control}
                name="selectedDays"
                render={({ field }) => (
                  <FormItem className="flex flex-row items-center space-x-2 space-y-0">
                    <FormControl>
                      <Checkbox
                        checked={field.value?.includes(day)}
                        onCheckedChange={(checked) => {
                          const updatedDays = checked
                            ? [...(field.value || []), day]
                            : (field.value || []).filter((d) => d !== day);
                          field.onChange(updatedDays);
                        }}
                      />
                    </FormControl>
                    <FormLabel className="text-sm font-normal">
                      {getDayTranslation(day)}
                    </FormLabel>
                  </FormItem>
                )}
              />
            ))}
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default DaySelectionField;
